// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Form, Input, message, Modal } from "antd";
import { PlusCircleOutlined } from "@ant-design/icons/lib";
import { formItemBlockLayout } from "../../../../utils/Constant";
import {
  requestCreateKeyword,
  requestGetKeywords
} from "../../../../state/keyword/KeywordEffects";
import { addKeyword } from "../../../../state/keyword/KeywordEvents";
import { KeywordInfoResponseDTO } from "../../../../api/backend-openapi";
import { useStore } from "effector-react";
import { KeywordStore } from "../../../../state/keyword/KeywordStore";
import { displayError } from "../../../../utils/displayError";

export const AddKeywordButton: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState<boolean>(false);
  const [form] = Form.useForm();

  const keywordStore: KeywordInfoResponseDTO[] | null = useStore(KeywordStore);

  const handleSubmit = (values: any) => {
    if (
      keywordStore.filter(keyword => keyword.text === values.text).length > 0
    ) {
      displayError("keywords.add.error.text");
    } else {
      requestCreateKeyword({
        text: values.text
      });
    }
  };

  useEffect(() => {
    return requestCreateKeyword.done.watch(({ result }) => {
      if (result.ok && result.data) {
        addKeyword(result.data);
        message.success(t("keywords.add.success"));
        form.resetFields();
        setVisible(false);
        requestGetKeywords();
      } else {
        displayError("keywords.add.error.generic");
      }
    });
  });

  return (
    <>
      <Button
        type="default"
        className="btn-secondary"
        onClick={() => setVisible(true)}
      >
        <PlusCircleOutlined />
        {t("keywords.global_buttons.add")}
      </Button>
      <Modal
        title={t("keywords.add.modal.title")}
        okText={t("global.confirm")}
        okButtonProps={{
          form: "add_keyword_form",
          htmlType: "submit"
        }}
        onCancel={() => {
          form.resetFields();
          setVisible(false);
        }}
        cancelText={t("global.cancel")}
        visible={visible}
        centered
      >
        <Form
          id="add_keyword_form"
          form={form}
          {...formItemBlockLayout}
          onFinish={handleSubmit}
        >
          <Form.Item
            name="text"
            label={<span>{t("keywords.add.form.text")}</span>}
            rules={[
              {
                required: true,
                message: t("global.empty_error_field"),
                whitespace: true
              }
            ]}
          >
            <Input id="text" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
